/**
 * - Validates for either MM/DD/YYYY or MM-DD-YYYY
 * @param {String} string
 */
export const validateDateString = (string) => {
  const regex = /^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/;
  return regex.test(string);
};
/**
 * @param {String} email
 */
export const emailValidation = (email) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};
/**
 * @param {String} code
 */
export const zipCodeValidation = (code) => {
  const regex = /^\d{5}$|^\d{5}-\d{4}$/;
  return regex.test(code);
};
/**
 * @param {String} phone
 */
export const phoneNumberValidation = (phone) => {
  const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return regex.test(phone);
};
/**
 * @param {String} string
 */
export const lowerCaseValidation = (string) => {
  const regex = /[a-z]/;
  return regex.test(string);
};
/**
 * @param {String} string
 */
export const upperCaseValidation = (string) => {
  const regex = /[A-Z]/;
  return regex.test(string);
};
/**
 * @param {String} string
 */
export const numberValidation = (string) => {
  const regex = /[0-9]/;
  return regex.test(string);
};
/**
 * @param {String} string
 */
export const specialCaseValidation = (string) => {
  const regex = /["!#$%&'()*+,-.\/\\:;<=>?@\[\]^_`{|}~]/;
  return regex.test(string);
};
/**
 * @param {String} string
 */
export const passwordLenValidation = (string) => {
  return string && string.length >= 8;
};
/**
 * - The string must contain at least 1 lowercase alphabetical character
 * - The string must contain at least 1 uppercase alphabetical character
 * - The string must contain at least 1 numeric character
 * - The string must be eight characters or longer
 * @param {String} password
 */
export const passwordValidation = (type, password) => {
  switch (type) {
    case "minimumlength8characters":
      return passwordLenValidation(password);
    case "oneLowerCaseCharacter":
      return lowerCaseValidation(password);
    case "oneUpperCaseCharacter":
      return upperCaseValidation(password);
    case "oneNumber":
      return numberValidation(password);
    case "symbolRequired":
      return specialCaseValidation(password);
    default:
      return false;
  }
};
